export default "__VITE_ASSET__d4c449e2__"